// extracted by mini-css-extract-plugin
export default {"adminTable":"AdminBusiness_adminTable__Ub1gt"};